// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"45cdc255","903":"7b56bfb5"}[chunkId] + ".chunk.js";
};